"use strict";
/* \
|*|  :: cookies.js ::
|*|
|*|  A complete cookies reader/writer framework with full unicode support.
|*|
|*|  https://developer.mozilla.org/en-US/docs/DOM/document.cookie
|*|
|*|  This framework is released under the GNU Public License, version 3 or later.
|*|  http://www.gnu.org/licenses/gpl-3.0-standalone.html
|*|
|*|  Syntaxes:
|*|
|*|  * docCookies.setItem(name, value[, end[, path[, domain[, secure]]]])
|*|  * docCookies.getItem(name)
|*|  * docCookies.removeItem(name[, path], domain)
|*|  * docCookies.hasItem(name)
|*|  * docCookies.keys()
|*|   对于永久cookie我们用了Fri, 31 Dec 9999 23:59:59 GMT作为过期日
\ */
const getKey = (key) => {
    if (!key) {
        return '';
    }
    let env = '';
    // let host = location.host
    // if (host.indexOf('sit') > -1) {
    //   env = 'sit_'
    // } else if (host.indexOf('dev') > -1) {
    //   env = 'dev_'
    // }
    return `${env}${key}`;
    // const env = process.env.NODE_ENV
    // return (env == 'production' ? '' : process.env.NODE_ENV + '_') + key
};
const docCookies = {
    getItem: function (sKey) {
        sKey = getKey(sKey);
        return (decodeURIComponent(document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' +
            encodeURIComponent(sKey).replace(/[-.+*]/g, '\\$&') +
            '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1')) || null);
    },
    setItem: function (sKey, sValue, vEnd, sPath = '/', sDomain, bSecure) {
        if (!sKey || /^(?:expires|max-age|path|domain|secure)$/i.test(sKey)) {
            return false;
        }
        sKey = getKey(sKey);
        if (!sDomain) {
            let hostname = location.hostname;
            if (/haoyishu.org$/.test(hostname)) {
                sDomain = 'haoyishu.org';
            }
            else if (/haoyishu.com$/.test(hostname)) {
                sDomain = 'haoyishu.com';
            }
            else if (/vzen.cn$/.test(hostname)) {
                sDomain = 'vzen.cn';
            }
            else {
                sDomain = hostname;
            }
        }
        let sExpires = '';
        if (vEnd) {
            switch (vEnd.constructor) {
                case Number:
                    sExpires =
                        vEnd === Infinity
                            ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT'
                            : '; max-age=' + vEnd;
                    break;
                case String:
                    sExpires = '; expires=' + vEnd;
                    break;
                case Date:
                    sExpires = '; expires=' + vEnd.toUTCString();
                    break;
            }
        }
        document.cookie =
            encodeURIComponent(sKey) +
                '=' +
                encodeURIComponent(sValue) +
                sExpires +
                (sDomain ? '; domain=' + sDomain : '') +
                (sPath ? '; path=' + sPath : '') +
                (bSecure ? '; secure' : '');
        return true;
    },
    removeItem: function (sKey, sPath = '/', sDomain) {
        if (!sKey || !this.hasItem(sKey)) {
            return false;
        }
        sKey = getKey(sKey);
        if (!sDomain) {
            let hostname = location.hostname;
            if (/haoyishu.org$/.test(hostname)) {
                sDomain = 'haoyishu.org';
            }
            else if (/haoyishu.com$/.test(hostname)) {
                sDomain = 'haoyishu.com';
            }
            else {
                sDomain = hostname;
            }
        }
        document.cookie =
            encodeURIComponent(sKey) +
                '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' +
                (sDomain ? '; domain=' + sDomain : '') +
                (sPath ? '; path=' + sPath : '');
        return true;
    },
    hasItem: function (sKey) {
        sKey = getKey(sKey);
        return new RegExp('(?:^|;\\s*)' +
            encodeURIComponent(sKey).replace(/[-.+*]/g, '\\$&') +
            '\\s*\\=').test(document.cookie);
    },
    keys: /* optional method: you can safely remove it! */ function () {
        const aKeys = document.cookie
            .replace(/((?:^|\s*;)[^=]+)(?=;|$)|^\s*|\s*(?:=[^;]*)?(?:\1|$)/g, '')
            .split(/\s*(?:=[^;]*)?;\s*/);
        for (let nIdx = 0; nIdx < aKeys.length; nIdx++) {
            aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]);
        }
        return aKeys;
    }
};
module.exports = docCookies;
